import { render, staticRenderFns } from "./yingYeYuXiaoFei.vue?vue&type=template&id=4da0a894&scoped=true&"
import script from "./yingYeYuXiaoFei.vue?vue&type=script&lang=js&"
export * from "./yingYeYuXiaoFei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0a894",
  null
  
)

export default component.exports